// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__2_iY5","item":"About_item__1qbYm","image":"About_image__36pQw","text":"About_text__onyJ3"};